module.exports = "<div>\n\t<img src=\"./assets/img/pac-404.png\"/>\n\t<p>Désolé! La page demandée est introuvable...</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main